import { map } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { companyCommand } from '../../command/company.command';
import { CompanyFortnoxConfigComponent } from '../../component/company-fortnox-config/company-fortnox-config.component';
import { Company } from '../../model/company';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class CompanyFortnoxConfigCommandHandler implements ICommandHandler {
  constructor(
    private _actionService: ActionWindowService,
    private _navService: NavigationService,
    private _injector: Injector
  ) {}

  canExecute(command: Command): boolean {
    return command.id === companyCommand.fortnoxConfig;
  }

  execute(command: Command): Observable<boolean> {
    return this._actionService.open(CompanyFortnoxConfigComponent, this._injector, null, command.context).pipe(
      map(result => {
        if (command.context instanceof Company) {
          // TODO: Maybe do nothing here?
          this._navService.reloadCurrentRoute();
          return true;
        }
        return false;
      })
    );
  }
}
